module.exports = __webpack_public_path__ + "img/n3.8a4cc4a5.jpg";